export const baseUrl = `https:${window.location.origin.substring(window.location.protocol.length)}`;
console.info("NEW BASE URL", baseUrl);
export let ApiFrom = "";
let ApiFromTls = "";
export const opeUrl = 'https://iaf-app.gke2.ope.gcp.renault.com';
export const opewafUrl = 'https://iaf-app.ope.apps.renault.com';
export const opeNewwafUrl = 'https://isa.renault.com';
// export const intUrl = 'https://iaf-app.ext.gke2.dev.gcp.renault.com';
export const intUrl = 'https://iaf-app.dev.apps.renault.com';
export const localUrl = 'https://localhost:4200';
export const keyAP = "";
export let ArcaApi = "";
export let ArcaApiTls = "";
const tlsEnable = "tls."
export const bvdOrbisUrl = 'https://orbis.bvdinfo.com/api/orbis/companies/';
export const newBvdOrbisUrl = 'https://api.bvdinfo.com/v1/orbis/Companies/';
export const share = 'https://wk2.renault.com/Runtime/Runtime/Form/ISA__'
export const dev = 'https://wkf-dev-alliance.corp.noxiane.net/Runtime/Runtime/Form/ISA__'
export const int = "https://wkf-int-alliance.corp.noxiane.net/Runtime/Runtime/Form/ISA__"
export const newShare = "https://wk2.renault.com//Runtime/Runtime/Form/ISA__"
export const shareLan = "https://wk2.renault.com/Runtime/Runtime/Form//ISA__Consult/?&language=EN&requestid="
export const intLan = "https://wkf-int-alliance.corp.noxiane.net/Runtime/Runtime/Form//ISA__Consult/?&language=EN&requestid="
export const re7ShareUrl = 'https://grouperenault.sharepoint.com/sites/xn--re7-isa-rfrentieldocumentaire-jucb/';
export const shareUrl = 'https://grouperenault.sharepoint.com/sites/isa-documentsrepository-prod/';
export const online = "https://suppliers-new.renault.com/fr/suppliers/isa-"
export const help = "https://grouperenault.sharepoint.com/sites/BOPISWEBSITESUPPORT/SitePages/ISA.aspx?csf=1&web=1&e=eOXX0G";
export const helplink = "https://synergyprod1.service-now.com/renault_worldwide?id=create_incident&sys_id=05074a0fdb63fb008de67b47f49619cf";
export const helpLink1 = 'https://suppliers-public.renault.com/Docs/ISAhome.pdf'
export const helpLinkProspectNoIpn = 'https://suppliers-new.renault.com/isa-information-page'
export const pdf = 'https://suppliers-public.renault.com/Docs/GDPR_EN.pdf'
export const pdf1 = 'https://suppliers-public.renault.com/Docs/GDPR_RSA.pdf'
export const google = 'https://www.google.com.sa/maps/search/'
export const guidecompanyLink = "https://suppliers-new.renault.com/isa-information-page"
export const guideLink = "https://suppliers-public.renault.com/Docs/ISA_GENERIC_DOCUMENTS_FOR_REFERENCE.pdf"
export const supplierMailLink = 'https://synergyprod1.service-now.com/renault_suppliers'
export const OktaUat = "https://renault-uat.okta.com/app/bookmark/0oaqee3q35I67XOO4417/login#"
export const OktaProd = "https://sso.renault.com/home/bookmark/0oauyo3gbdKqdWpCl417/2557";
if (baseUrl == opeUrl || baseUrl == opewafUrl || baseUrl== opeNewwafUrl) {
  ApiFrom = "https://apis."; 

  ArcaApi = ApiFrom;
} else {
  ApiFrom = "https://apis-qa."
  if (baseUrl == localUrl || baseUrl == `${localUrl}/`) {
    ApiFromTls = ApiFrom
  } else {
    ApiFromTls = "https://apis-qa."
  }
  if (baseUrl == localUrl || baseUrl == `${localUrl}/` ) 
  {
    ArcaApi = "https://apis-qa."; 
  } else if (baseUrl == 'https://iaf-app.dev.apps.renault.com' || baseUrl == 'https://iaf-app.int.apps.renault.com' || baseUrl == 'https://iaf-app-ppd.int.apps.renault.com' 
    || baseUrl == 'https://iaf-app.ext.gke2.int.gcp.renault.com' || baseUrl == 'https://iaf-app.ext.gke2.dev.gcp.renault.com' || baseUrl == 'https://iaf-app-ppd.ext.gke2.int.gcp.renault.com' ) {
    ArcaApi = "https://apis-qa."; 

  } else if ( baseUrl == 'https://sta.iaf.dev.aws.renault.com') {
    ArcaApi = "https://apis-pp."; 
  }
  ArcaApiTls = "https://apis-dev";
}

export const appConfig = {
  ApiArcaURL: `${ApiFrom}renault.com/arca/acs/v1/`,
  SupplierserviceUrl:  baseUrl == localUrl ?`${intUrl}/api/supplier` :`${baseUrl}/api/supplier`,
  vendorUrl:  baseUrl == localUrl ?`${intUrl}/api/vendor` :`${baseUrl}/api/vendor`,
  contactServiceUrl :baseUrl == localUrl ?`${intUrl}/api/contacts` :`${baseUrl}/api/contacts`,
  SitesServiceUrl:  baseUrl == localUrl ? `${intUrl}/api/sites` :`${baseUrl}/api/sites`,  
  K2SocleServiceUrl:baseUrl == localUrl ?`${intUrl}/api/k2` :`${baseUrl}/api/k2`,
  PurchasingServiceUrl:baseUrl == localUrl ?`${intUrl}/api/purchasing` :`${baseUrl}/api/purchasing`,
  ArcaServiceUrl:baseUrl == localUrl ?`${intUrl}/api/arca` :`${baseUrl}/api/arca`,
  SustainServiceUrl: baseUrl == localUrl ?`${intUrl}/api/sustain` :`${baseUrl}/api/sustain`,
  ApiSupplierUrl: `${ApiFrom}renault.com/enterprise-repositories-alliance-suppliers/v1/`,
  ApiPurchasingUrl: `${ApiFrom}renault.com/enterprise-repositories-purchasing/v3/`,
  ApiContactsUrl: `${ApiFrom}renault.com/enterprise-repositories-alliance-supplier-contacts/v1/`,
  ApinewContactsUrl: `${ApiFrom}renault.com/enterprise-repositories-alliance-supplier-contacts/v2/`,
  ApiSitesUrl: `${ApiFrom}renault.com/enterprise-repositories-alliance-sites/v2/`,
  ApiSustainUrl: `${ApiFrom}renault.com/procurement/supplier-risk-quotation/v1/`,
  ApiVendorUrl: `${ApiFrom}renault.com/finances/vendors-info/v1/`,
  ApiCountryUrl: `${ApiFrom}renault.com/countries-and-grouping/v1/`,
  CountryServiceUrl: baseUrl == localUrl ?`${intUrl}/api/country` :`${baseUrl}/api/country`,
  ApiAddressUrl: `${ApiFrom}renault.com/addresses/v1/`,
  AddressServiceUrl: baseUrl == localUrl ?`${intUrl}/api/address` :`${baseUrl}/api/address`,
  ApiK2Url: `${ArcaApi}renault.com/k2-isa/v1/`, 
  ApiK2SocleUrl: `${ArcaApi}renault.com/k2-socle/v1/`,

  bvdOrbisUrl: newBvdOrbisUrl,

  SupplierAuthorization: "Basic ZGV2ZWxvcGVyOnN1cERldmVsb3Blcg==",
  PurchasingAuthorization: "Basic ZGV2ZWxvcGVyOnB1ckRldmVsb3Blcg==",
  SitesAuthorization: "Basic YXdpc2EwMjoxSUFGMjAxOQ==",

  ApiSitesUrlTemp: "https://re7.rfs.re7.aws.renault.com/sites/v2/",

  apikey: keyAP,
  token_url: "https://idp2.renault.com/nidp/oauth/nam/token",
  loadingImg: 'data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==',

};
